import SearchRoadRoutingResponse, {
  SearchRoadRoutingResponseRoute,
} from "../../../utils/search-road-route/search-road-routing.response";
import PlanEntryRoadRoute from "./plan-entry-road-route";

const createRoute = (
  route: SearchRoadRoutingResponseRoute,
): PlanEntryRoadRoute => {
  return {
    coordinates: route.geometry.coordinates,
    legs: route.legs,
  };
};

const create = (response: SearchRoadRoutingResponse): PlanEntryRoadRoute[] => {
  return response.routes.map(createRoute);
};

const planEntryRoadRouteFactory = {
  create,
};

export default planEntryRoadRouteFactory;
